export default "__VITE_ASSET__fad65bce__"